/** Quick Cashflow UI palette (from quickCashflow.scss) for Excel exports. */
export const EXCEL_THEME = {
  brand: 'FF2E2F66',
  brandText: 'FFFFFFFF',
  accent: 'FF4A4FCF',
  section: 'FFEEF0FE',
  sectionText: 'FF2E2F66',
  labelBg: 'FFFAFAFE',
  border: 'FFEEF0FE',
  negative: 'FFB22A2A',
  totalCol: 'FFE8EBFB',
  annotation: 'FF9498B5',
  actualBg: 'FFE8EBFB',
  actualText: 'FF4A4FCF',
  forecastBg: 'FFFEF4E8',
  forecastText: 'FFB26900',
  predictedFill: 'FFC6EFCE',
  white: 'FFFFFFFF',
};

export const MONEY_NUM_FMT = '$#,##0;[Red]($#,##0)';
export const PCT_NUM_FMT = '0.000%';
